import Image from 'next/image';

import styles from './Header.module.scss';

interface Props {
  title: string;
}

const Header: React.FC<Props> = ({ title }) => {
  return (
    <div className={styles.header}>
      <Image src="/images/contact-heading.jpg" alt="" fill />
      <h2>{title}</h2>
    </div>
  );
};
export default Header;
